/**
 * CLEARSTEM HSN A/B Price Test
 *
 * When activated by Convert.com variation, this script swaps the
 * "hair-skin-nails" product ($58) with "hair-skin-nails-2" ($54)
 * across all surfaces on the site.
 *
 * Surfaces handled:
 * - PDP (product detail page) — purchase options, subscriptions, forms
 * - Product cards (collections, search, carousels, complete your routine)
 * - Cart drawer recommendations
 * - Product recommendations
 * - Subscription products page
 *
 * Convert.com variation sets: window.__csHsnPriceTest = true
 * Then dispatches: document.dispatchEvent(new Event('csHsnPriceTestActivated'))
 */
(function () {
    'use strict';

    // === PRODUCT MAPPING ===
    var ORIGINAL = {
        productId: '9245938385121',
        variantId: '47603388055777',
        handle: 'hair-skin-nails',
        price: 5800,
        sellingPlans: {
            '5356290273': true,
            '5356323041': true,
            '5356355809': true
        }
    };

    var TEST = {
        productId: '9399483793633',
        variantId: '48041195569377',
        handle: 'hair-skin-nails-2',
        price: 5400
    };

    // Selling plan ID mapping (original -> test)
    var SELLING_PLAN_MAP = {
        '5356290273': '5507580129',
        '5356323041': '5507612897',
        '5356355809': '5507645665'
    };

    var DISCOUNT_PCT = 15;
    var activated = false;
    var testProductDataCache = null;

    // === HELPERS ===
    function formatMoney(cents) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(cents / 100);
    }

    function formatMoneyShort(cents) {
        var d = cents / 100;
        return d % 1 === 0 ? '$' + d.toFixed(0) : '$' + d.toFixed(2);
    }

    function subPrice(cents) {
        return Math.round(cents * (1 - DISCOUNT_PCT / 100));
    }

    function isOriginalProductId(val) {
        return String(val) === ORIGINAL.productId;
    }

    function isOriginalVariantId(val) {
        return String(val) === ORIGINAL.variantId;
    }

    function isOriginalSellingPlan(val) {
        return SELLING_PLAN_MAP.hasOwnProperty(String(val));
    }

    function isSubscriptionSelected() {
        // Check if the subscribe radio input is checked
        var subInput = document.querySelector('input[name="purchase_type"][value="subscribe"]');
        if (subInput && subInput.checked) return true;
        // Fallback: check if the subscribe radio option has --selected class
        var radios = document.querySelectorAll('.purchase-options__radio-option');
        for (var i = 0; i < radios.length; i++) {
            var input = radios[i].querySelector('input[value="subscribe"]');
            if (input && radios[i].classList.contains('purchase-options__radio-option--selected')) {
                return true;
            }
        }
        return false;
    }

    function matchesOriginalPrice(text) {
        var t = text.trim();
        return t === formatMoneyShort(ORIGINAL.price) ||
            t === formatMoney(ORIGINAL.price);
    }

    function matchesOriginalSubPrice(text) {
        var t = text.trim();
        var osp = subPrice(ORIGINAL.price);
        return t === formatMoneyShort(osp) || t === formatMoney(osp);
    }

    // === FETCH TEST PRODUCT DATA (for PDP usage) ===
    function getTestProductData() {
        if (testProductDataCache) {
            return Promise.resolve(testProductDataCache);
        }
        // Check if pre-loaded by the theme (inline script on PDP)
        if (window.__csHsnTestProductData) {
            testProductDataCache = window.__csHsnTestProductData;
            return Promise.resolve(testProductDataCache);
        }
        return fetch('/products/hair-skin-nails-2.js')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                testProductDataCache = data;
                window.__csHsnTestProductData = data;
                return data;
            });
    }

    // === SWAP PRODUCT CARDS ===
    function swapProductCards(root) {
        if (!root) return;

        // Swap ATC buttons with original product/variant IDs
        var btns = root.querySelectorAll(
            'button[data-product-id="' + ORIGINAL.productId + '"],' +
            'button[data-variant-id="' + ORIGINAL.variantId + '"],' +
            '[data-product-id="' + ORIGINAL.productId + '"].add-to-cart-button'
        );

        btns.forEach(function (btn) {
            // Skip PDP purchase options button (handled separately)
            if (btn.classList.contains('purchase-options__add-button')) return;

            if (isOriginalProductId(btn.getAttribute('data-product-id'))) {
                btn.setAttribute('data-product-id', TEST.productId);
            }
            if (isOriginalVariantId(btn.getAttribute('data-variant-id'))) {
                btn.setAttribute('data-variant-id', TEST.variantId);
            }
            var sp = btn.getAttribute('data-selling-plan-id');
            if (sp && SELLING_PLAN_MAP[sp]) {
                btn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
            }

            // Swap price text
            var priceSpan = btn.querySelector('.button-price');
            if (priceSpan) {
                var txt = priceSpan.textContent.trim();
                if (matchesOriginalPrice(txt)) {
                    priceSpan.textContent = formatMoneyShort(TEST.price);
                } else if (matchesOriginalSubPrice(txt)) {
                    priceSpan.textContent = formatMoneyShort(subPrice(TEST.price));
                }
            }

            // Swap compare-at price
            var cmp = btn.querySelector('.cs-product-card__button-compare-price');
            if (cmp && matchesOriginalPrice(cmp.textContent)) {
                cmp.textContent = formatMoneyShort(TEST.price);
            }
        });

        // Swap hidden form inputs (card-product.liquid quick-add forms)
        var hiddenInputs = root.querySelectorAll(
            'input[name="id"][value="' + ORIGINAL.variantId + '"]'
        );
        hiddenInputs.forEach(function (input) {
            input.value = TEST.variantId;
        });

        // Swap recommendation data divs (product-recommendations.liquid)
        var recDivs = root.querySelectorAll(
            '.product-recommendation[data-product-id="' + ORIGINAL.productId + '"],' +
            '[data-product-id="' + ORIGINAL.productId + '"][data-product-price]'
        );
        recDivs.forEach(function (div) {
            div.setAttribute('data-product-id', TEST.productId);
            if (div.hasAttribute('data-product-variant-id')) {
                div.setAttribute('data-product-variant-id', TEST.variantId);
            }
            if (div.hasAttribute('data-product-price')) {
                div.setAttribute('data-product-price', formatMoney(TEST.price));
            }
        });

        // Swap Dawn price.liquid rendered prices (for card-product.liquid)
        var priceItems = root.querySelectorAll('.price-item--regular, .price-item--sale, .price-item--last');
        priceItems.forEach(function (el) {
            if (matchesOriginalPrice(el.textContent)) {
                // Check if this price is inside a card for the original product
                var card = el.closest('[data-product-id="' + TEST.productId + '"]') ||
                    el.closest('.product-card-wrapper');
                if (card) {
                    el.textContent = formatMoney(TEST.price);
                }
            }
        });

        // Swap subscription products page prices
        var subOrigPrices = root.querySelectorAll('.cs-subscription-products__button-original-price');
        subOrigPrices.forEach(function (el) {
            if (matchesOriginalPrice(el.textContent)) {
                var card = el.closest('[data-product-id]');
                if (card && isOriginalProductId(card.getAttribute('data-product-id'))) {
                    el.textContent = formatMoneyShort(TEST.price);
                }
            }
        });
    }

    // === SWAP DYNAMICALLY RENDERED CART DRAWER RECOMMENDATIONS ===
    function swapCartDrawerRecs(root) {
        if (!root) return;

        // Cart drawer builds recommendation cards from data divs
        // The rendered cards use ATC buttons with data-product-id and data-variant-id
        var cards = root.querySelectorAll('.cart-drawer__product-card');
        cards.forEach(function (card) {
            var btn = card.querySelector('.add-to-cart-button');
            if (!btn) return;
            if (!isOriginalProductId(btn.getAttribute('data-product-id')) &&
                !isOriginalVariantId(btn.getAttribute('data-variant-id'))) return;

            if (isOriginalProductId(btn.getAttribute('data-product-id'))) {
                btn.setAttribute('data-product-id', TEST.productId);
            }
            if (isOriginalVariantId(btn.getAttribute('data-variant-id'))) {
                btn.setAttribute('data-variant-id', TEST.variantId);
            }

            // Swap price text in the card
            var priceEl = card.querySelector('.cart-drawer__product-price');
            if (priceEl && matchesOriginalPrice(priceEl.textContent)) {
                priceEl.textContent = formatMoney(TEST.price);
            }
        });
    }

    // === SWAP PDP ===
    function swapPDP() {
        // Only run on the hair-skin-nails PDP (not hair-skin-nails-2)
        var path = window.location.pathname;
        if (path.indexOf('/products/hair-skin-nails') === -1) return;
        if (path.indexOf('/products/hair-skin-nails-2') !== -1) return;

        getTestProductData().then(function (testData) {
            performPDPSwap(testData);
        }).catch(function (err) {
            console.error('[HSN A/B Test] Failed to load test product data:', err);
        });
    }

    function performPDPSwap(testData) {
        // 1. Override primaryProductData if available
        if (typeof window.primaryProductData !== 'undefined') {
            overridePrimaryProductData(window.primaryProductData, testData);
        }

        // 2. Update form hidden inputs
        var forms = document.querySelectorAll('form[data-product-form]');
        forms.forEach(function (form) {
            var idInput = form.querySelector('input[name="id"]');
            if (idInput && isOriginalVariantId(idInput.value)) {
                idInput.value = TEST.variantId;
            }
        });

        // 3. Update ATC button
        var atcBtn = document.querySelector('.purchase-options__add-button');
        if (atcBtn) {
            if (isOriginalProductId(atcBtn.getAttribute('data-product-id'))) {
                atcBtn.setAttribute('data-product-id', TEST.productId);
            }
            if (isOriginalVariantId(atcBtn.getAttribute('data-variant-id'))) {
                atcBtn.setAttribute('data-variant-id', TEST.variantId);
            }
            var sp = atcBtn.getAttribute('data-selling-plan-id');
            if (sp && SELLING_PLAN_MAP[sp]) {
                atcBtn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
            }
        }

        // 4. Update price displays
        updatePDPPrices();

        // 5. Update selling plan selects
        updateSellingPlanSelects();

        // 6. Patch the purchase options JS to use new data on interaction
        patchPurchaseOptionsInteractions(testData);
    }

    function overridePrimaryProductData(primary, testData) {
        primary.id = testData.id;
        primary.handle = testData.handle;
        primary.variants = testData.variants;
        primary.selling_plan_groups = testData.selling_plan_groups;
    }

    function updatePDPPrices() {
        var testSub = subPrice(TEST.price);

        // One-time price display
        var otPrice = document.querySelector('[data-onetime-price]');
        if (otPrice) {
            otPrice.textContent = formatMoney(TEST.price);
        }

        // One-time price in radio label
        var otRadioPrice = document.querySelector('.purchase-options__radio-price[data-onetime-price]');
        if (otRadioPrice) {
            otRadioPrice.textContent = formatMoney(TEST.price);
        }

        // Subscription price display
        var subPriceEl = document.querySelector('[data-subscription-price]');
        if (subPriceEl) {
            subPriceEl.textContent = formatMoney(testSub);
        }
        var subRadioPrice = document.querySelector('.subscription-price[data-subscription-price]');
        if (subRadioPrice) {
            subRadioPrice.textContent = formatMoney(testSub);
        }

        // ATC button price
        var btnPrice = document.querySelector('.purchase-options__add-button .button-price');
        if (btnPrice) {
            var isSubSelected = isSubscriptionSelected();
            if (isSubSelected) {
                btnPrice.textContent = formatMoney(testSub);
            } else {
                btnPrice.textContent = formatMoney(TEST.price);
            }
        }

        // Compare-at price elements
        var comparePrices = document.querySelectorAll('.purchase-options__radio-compare-price');
        comparePrices.forEach(function (el) {
            if (matchesOriginalPrice(el.textContent)) {
                el.textContent = formatMoney(TEST.price);
            }
        });

        // Hidden price display
        var hiddenPrice = document.querySelector('.product-details__price .price-item--regular');
        if (hiddenPrice && matchesOriginalPrice(hiddenPrice.textContent)) {
            hiddenPrice.textContent = formatMoney(TEST.price);
        }

        // Installments / afterpay text
        var installTexts = document.querySelectorAll('.purchase-options__installments, .afterpay-paragraph');
        installTexts.forEach(function (el) {
            var origInstallment = formatMoney(Math.round(ORIGINAL.price / 4));
            var testInstallment = formatMoney(Math.round(TEST.price / 4));
            if (el.innerHTML.indexOf(origInstallment) !== -1) {
                el.innerHTML = el.innerHTML.replace(origInstallment, testInstallment);
            }
        });
    }

    function updateSellingPlanSelects() {
        // Hidden selling_plan select
        var spSelect = document.getElementById('selling_plan_select');
        if (spSelect) {
            var opts = spSelect.querySelectorAll('option');
            opts.forEach(function (opt) {
                if (SELLING_PLAN_MAP[opt.value]) {
                    opt.value = SELLING_PLAN_MAP[opt.value];
                }
            });
        }

        // Frequency select (Choices.js enhanced)
        var freqSelect = document.getElementById('subscription-frequency');
        if (freqSelect) {
            var opts = freqSelect.querySelectorAll('option');
            opts.forEach(function (opt) {
                if (SELLING_PLAN_MAP[opt.value]) {
                    opt.value = SELLING_PLAN_MAP[opt.value];
                }
            });
        }

        // If Choices.js has already initialized, update the Choices instance too
        var choicesContainer = document.querySelector('.purchase-options__frequency-select');
        if (choicesContainer && choicesContainer._choices) {
            try {
                var choices = choicesContainer._choices;
                var items = choices._store.choices;
                items.forEach(function (item) {
                    if (SELLING_PLAN_MAP[item.value]) {
                        item.value = SELLING_PLAN_MAP[item.value];
                    }
                });
            } catch (e) {
                // Choices.js internals may vary
            }
        }
    }

    function patchPurchaseOptionsInteractions(testData) {
        // Intercept radio option clicks to update price with test data
        var radioOptions = document.querySelectorAll('.purchase-options__radio-option');
        radioOptions.forEach(function (radio) {
            radio.addEventListener('click', function () {
                // Brief delay to let the existing JS run first, then correct prices
                setTimeout(function () {
                    updatePDPPrices();
                    // Re-map selling plan on ATC button
                    var atcBtn = document.querySelector('.purchase-options__add-button');
                    if (atcBtn) {
                        var sp = atcBtn.getAttribute('data-selling-plan-id');
                        if (sp && SELLING_PLAN_MAP[sp]) {
                            atcBtn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
                        }
                        // Ensure product/variant IDs stay swapped
                        atcBtn.setAttribute('data-product-id', TEST.productId);
                        atcBtn.setAttribute('data-variant-id', TEST.variantId);
                    }
                }, 50);
            });
        });

        // Intercept frequency dropdown changes
        var freqSelect = document.getElementById('subscription-frequency');
        if (freqSelect) {
            freqSelect.addEventListener('change', function () {
                setTimeout(function () {
                    updateSellingPlanSelects();
                    var atcBtn = document.querySelector('.purchase-options__add-button');
                    if (atcBtn) {
                        var sp = atcBtn.getAttribute('data-selling-plan-id');
                        if (sp && SELLING_PLAN_MAP[sp]) {
                            atcBtn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
                        }
                    }
                    updatePDPPrices();
                }, 50);
            });
        }

        // Also watch for Choices.js custom events
        var choicesContainer = document.querySelector('.choices');
        if (choicesContainer) {
            choicesContainer.addEventListener('choice', function () {
                setTimeout(function () {
                    updateSellingPlanSelects();
                    var atcBtn = document.querySelector('.purchase-options__add-button');
                    if (atcBtn) {
                        var sp = atcBtn.getAttribute('data-selling-plan-id');
                        if (sp && SELLING_PLAN_MAP[sp]) {
                            atcBtn.setAttribute('data-selling-plan-id', SELLING_PLAN_MAP[sp]);
                        }
                    }
                    updatePDPPrices();
                }, 100);
            });
        }
    }

    // === MUTATION OBSERVER ===
    function setupObserver() {
        var observer = new MutationObserver(function (mutations) {
            var needsSwap = false;
            for (var i = 0; i < mutations.length; i++) {
                var added = mutations[i].addedNodes;
                for (var j = 0; j < added.length; j++) {
                    var node = added[j];
                    if (node.nodeType !== 1) continue;

                    // Check if new content contains original HSN references
                    if (node.querySelector) {
                        if (node.querySelector('[data-product-id="' + ORIGINAL.productId + '"]') ||
                            node.querySelector('[data-variant-id="' + ORIGINAL.variantId + '"]') ||
                            node.querySelector('input[name="id"][value="' + ORIGINAL.variantId + '"]')) {
                            needsSwap = true;
                            break;
                        }
                    }
                    if (node.getAttribute) {
                        if (isOriginalProductId(node.getAttribute('data-product-id')) ||
                            isOriginalVariantId(node.getAttribute('data-variant-id'))) {
                            needsSwap = true;
                            break;
                        }
                    }
                }
                if (needsSwap) break;
            }

            if (needsSwap) {
                swapProductCards(document);
                swapCartDrawerRecs(document);
            }
        });

        observer.observe(document.body || document.documentElement, {
            childList: true,
            subtree: true
        });
    }

    // === INTERCEPT FETCH TO SWAP RECOMMENDATIONS ===
    function patchFetch() {
        var origFetch = window.fetch;
        window.fetch = function () {
            var url = arguments[0];
            if (typeof url === 'string' && url.indexOf('product-recommendations') !== -1) {
                return origFetch.apply(this, arguments).then(function (response) {
                    // After recommendations load, swap any HSN references
                    setTimeout(function () {
                        swapProductCards(document);
                        swapCartDrawerRecs(document);
                    }, 200);
                    return response;
                });
            }
            return origFetch.apply(this, arguments);
        };
    }

    // === INTERCEPT SECTION RENDERING (cart drawer updates) ===
    function patchSectionRendering() {
        // After cart updates, the cart drawer re-renders sections
        // Watch for the cart drawer opening and swap recs
        document.addEventListener('click', function (e) {
            var trigger = e.target.closest('[data-cart-trigger]') ||
                e.target.closest('.header__icon--cart') ||
                e.target.closest('#cart-icon-bubble') ||
                e.target.closest('.cart-count-bubble');
            if (trigger) {
                // Cart drawer is about to open, apply swaps after render
                setTimeout(function () {
                    swapProductCards(document);
                    swapCartDrawerRecs(document);
                }, 500);
                setTimeout(function () {
                    swapProductCards(document);
                    swapCartDrawerRecs(document);
                }, 1500);
            }
        });
    }

    // === MAIN ===
    function runTest() {
        if (activated) return;
        activated = true;

        // Apply swaps to current page content
        swapProductCards(document);
        swapCartDrawerRecs(document);
        swapPDP();

        // Set up watchers for dynamic content
        if (document.body) {
            setupObserver();
        } else {
            document.addEventListener('DOMContentLoaded', setupObserver);
        }

        patchFetch();
        patchSectionRendering();

        // Re-apply swaps after full DOM load
        if (document.readyState !== 'complete') {
            window.addEventListener('load', function () {
                swapProductCards(document);
                swapCartDrawerRecs(document);
            });
        }

        // Also re-apply after a short delay to catch late-loading content
        setTimeout(function () {
            swapProductCards(document);
            swapCartDrawerRecs(document);
        }, 1000);
        setTimeout(function () {
            swapProductCards(document);
            swapCartDrawerRecs(document);
        }, 3000);
    }

    // Expose globally for Convert to call
    window.__csRunHsnPriceTest = runTest;

    // If Convert has already set the flag (Convert runs in <head> synchronously)
    if (window.__csHsnPriceTest) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', runTest);
        } else {
            runTest();
        }
    }

    // Listen for late activation (if Convert loads async)
    document.addEventListener('csHsnPriceTestActivated', function () {
        if (!activated) {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', runTest);
            } else {
                runTest();
            }
        }
    });
})();
